export default {
    "provinces": [{
            "label": "北京市",
            "level": "1",
            "code": "1100",
            "cities": [{
                "label": "北京市",
                "level": "1",
                "code": "1100"
            }]
        },
        {
            "label": "天津市",
            "level": "1",
            "code": "1200",
            "cities": [{
                "label": "天津市",
                "level": "1",
                "code": "1200"
            }]
        },
        {
            "label": "河北省",
            "level": "1",
            "code": "1300",
            "cities": [{
                    "label": "石家庄市",
                    "level": "2",
                    "code": "1301"
                },
                {
                    "label": "唐山市",
                    "level": "3",
                    "code": "1302"
                },
                {
                    "label": "秦皇岛市",
                    "level": "3",
                    "code": "1303"
                },
                {
                    "label": "邯郸市",
                    "level": "3",
                    "code": "1304"
                },
                {
                    "label": "邢台市",
                    "level": "3",
                    "code": "1305"
                },
                {
                    "label": "保定市",
                    "level": "3",
                    "code": "1306"
                },
                {
                    "label": "张家口市",
                    "level": "3",
                    "code": "1307"
                },
                {
                    "label": "承德市",
                    "level": "3",
                    "code": "1308"
                },
                {
                    "label": "沧州市",
                    "level": "3",
                    "code": "1309"
                },
                {
                    "label": "廊坊市",
                    "level": "3",
                    "code": "1310"
                },
                {
                    "label": "衡水市",
                    "level": "3",
                    "code": "1311"
                }
            ]
        },
        {
            "label": "山西省",
            "level": "1",
            "code": "1400",
            "cities": [{
                    "label": "太原市",
                    "level": "2",
                    "code": "1401"
                },
                {
                    "label": "大同市",
                    "level": "3",
                    "code": "1402"
                },
                {
                    "label": "阳泉市",
                    "level": "3",
                    "code": "1403"
                },
                {
                    "label": "长治市",
                    "level": "3",
                    "code": "1404"
                },
                {
                    "label": "晋城市",
                    "level": "3",
                    "code": "1405"
                },
                {
                    "label": "朔州市",
                    "level": "3",
                    "code": "1406"
                },
                {
                    "label": "晋中市",
                    "level": "3",
                    "code": "1407"
                },
                {
                    "label": "运城市",
                    "level": "3",
                    "code": "1408"
                },
                {
                    "label": "忻州市",
                    "level": "3",
                    "code": "1409"
                },
                {
                    "label": "临汾市",
                    "level": "3",
                    "code": "1410"
                },
                {
                    "label": "吕梁市",
                    "level": "3",
                    "code": "1411"
                }
            ]
        },
        {
            "label": "内蒙古自治区",
            "level": "1",
            "code": "1500",
            "cities": [{
                    "label": "呼和浩特市",
                    "level": "2",
                    "code": "1501"
                },
                {
                    "label": "包头市",
                    "level": "3",
                    "code": "1502"
                },
                {
                    "label": "乌海市",
                    "level": "3",
                    "code": "1503"
                },
                {
                    "label": "赤峰市",
                    "level": "3",
                    "code": "1504"
                },
                {
                    "label": "通辽市",
                    "level": "3",
                    "code": "1505"
                },
                {
                    "label": "鄂尔多斯市",
                    "level": "3",
                    "code": "1506"
                },
                {
                    "label": "呼伦贝尔市",
                    "level": "3",
                    "code": "1507"
                },
                {
                    "label": "巴彦淖尔市",
                    "level": "3",
                    "code": "1508"
                },
                {
                    "label": "乌兰察布市",
                    "level": "3",
                    "code": "1509"
                },
                {
                    "label": "兴安盟",
                    "level": "3",
                    "code": "1522"
                },
                {
                    "label": "锡林郭勒盟",
                    "level": "3",
                    "code": "1525"
                },
                {
                    "label": "阿拉善盟",
                    "level": "3",
                    "code": "1529"
                }
            ]
        },
        {
            "label": "辽宁省",
            "level": "1",
            "code": "2100",
            "cities": [{
                    "label": "沈阳市",
                    "level": "2",
                    "code": "2101"
                },
                {
                    "label": "大连市",
                    "level": "3",
                    "code": "2102"
                },
                {
                    "label": "鞍山市",
                    "level": "3",
                    "code": "2103"
                },
                {
                    "label": "抚顺市",
                    "level": "3",
                    "code": "2104"
                },
                {
                    "label": "本溪市",
                    "level": "3",
                    "code": "2105"
                },
                {
                    "label": "丹东市",
                    "level": "3",
                    "code": "2106"
                },
                {
                    "label": "锦州市",
                    "level": "3",
                    "code": "2107"
                },
                {
                    "label": "营口市",
                    "level": "3",
                    "code": "2108"
                },
                {
                    "label": "阜新市",
                    "level": "3",
                    "code": "2109"
                },
                {
                    "label": "辽阳市",
                    "level": "3",
                    "code": "2110"
                },
                {
                    "label": "盘锦市",
                    "level": "3",
                    "code": "2111"
                },
                {
                    "label": "铁岭市",
                    "level": "3",
                    "code": "2112"
                },
                {
                    "label": "朝阳市",
                    "level": "3",
                    "code": "2113"
                },
                {
                    "label": "葫芦岛市",
                    "level": "3",
                    "code": "2114"
                }
            ]
        },
        {
            "label": "吉林省",
            "level": "1",
            "code": "2200",
            "cities": [{
                    "label": "长春市",
                    "level": "2",
                    "code": "2201"
                },
                {
                    "label": "吉林市",
                    "level": "3",
                    "code": "2202"
                },
                {
                    "label": "四平市",
                    "level": "3",
                    "code": "2203"
                },
                {
                    "label": "辽源市",
                    "level": "3",
                    "code": "2204"
                },
                {
                    "label": "通化市",
                    "level": "3",
                    "code": "2205"
                },
                {
                    "label": "白山市",
                    "level": "3",
                    "code": "2206"
                },
                {
                    "label": "松原市",
                    "level": "3",
                    "code": "2207"
                },
                {
                    "label": "白城市",
                    "level": "3",
                    "code": "2208"
                },
                {
                    "label": "延边朝鲜族自治州",
                    "level": "3",
                    "code": "2224"
                }
            ]
        },
        {
            "label": "黑龙江省",
            "level": "1",
            "code": "2300",
            "cities": [{
                    "label": "哈尔滨市",
                    "level": "2",
                    "code": "2301"
                },
                {
                    "label": "齐齐哈尔市",
                    "level": "3",
                    "code": "2302"
                },
                {
                    "label": "鸡西市",
                    "level": "3",
                    "code": "2303"
                },
                {
                    "label": "鹤岗市",
                    "level": "3",
                    "code": "2304"
                },
                {
                    "label": "双鸭山市",
                    "level": "3",
                    "code": "2305"
                },
                {
                    "label": "大庆市",
                    "level": "3",
                    "code": "2306"
                },
                {
                    "label": "伊春市",
                    "level": "3",
                    "code": "2307"
                },
                {
                    "label": "佳木斯市",
                    "level": "3",
                    "code": "2308"
                },
                {
                    "label": "七台河市",
                    "level": "3",
                    "code": "2309"
                },
                {
                    "label": "牡丹江市",
                    "level": "3",
                    "code": "2310"
                },
                {
                    "label": "黑河市",
                    "level": "3",
                    "code": "2311"
                },
                {
                    "label": "绥化市",
                    "level": "3",
                    "code": "2312"
                },
                {
                    "label": "大兴安岭地区",
                    "level": "3",
                    "code": "2327"
                }
            ]
        },
        {
            "label": "上海市",
            "level": "1",
            "code": "3100",
            "cities": [{
                "label": "上海市",
                "level": "1",
                "code": "3100"
            }]
        },
        {
            "label": "江苏省",
            "level": "1",
            "code": "3200",
            "cities": [{
                    "label": "南京市",
                    "level": "2",
                    "code": "3201"
                },
                {
                    "label": "无锡市",
                    "level": "3",
                    "code": "3202"
                },
                {
                    "label": "徐州市",
                    "level": "3",
                    "code": "3203"
                },
                {
                    "label": "常州市",
                    "level": "3",
                    "code": "3204"
                },
                {
                    "label": "苏州市",
                    "level": "3",
                    "code": "3205"
                },
                {
                    "label": "南通市",
                    "level": "3",
                    "code": "3206"
                },
                {
                    "label": "连云港市",
                    "level": "3",
                    "code": "3207"
                },
                {
                    "label": "淮安市",
                    "level": "3",
                    "code": "3208"
                },
                {
                    "label": "盐城市",
                    "level": "3",
                    "code": "3209"
                },
                {
                    "label": "扬州市",
                    "level": "3",
                    "code": "3210"
                },
                {
                    "label": "镇江市",
                    "level": "3",
                    "code": "3211"
                },
                {
                    "label": "泰州市",
                    "level": "3",
                    "code": "3212"
                },
                {
                    "label": "宿迁市",
                    "level": "3",
                    "code": "3213"
                }
            ]
        },
        {
            "label": "浙江省",
            "level": "1",
            "code": "3300",
            "cities": [{
                    "label": "杭州市",
                    "level": "2",
                    "code": "3301"
                },
                {
                    "label": "宁波市",
                    "level": "3",
                    "code": "3302"
                },
                {
                    "label": "温州市",
                    "level": "3",
                    "code": "3303"
                },
                {
                    "label": "嘉兴市",
                    "level": "3",
                    "code": "3304"
                },
                {
                    "label": "湖州市",
                    "level": "3",
                    "code": "3305"
                },
                {
                    "label": "绍兴市",
                    "level": "3",
                    "code": "3306"
                },
                {
                    "label": "金华市",
                    "level": "3",
                    "code": "3307"
                },
                {
                    "label": "衢州市",
                    "level": "3",
                    "code": "3308"
                },
                {
                    "label": "舟山市",
                    "level": "3",
                    "code": "3309"
                },
                {
                    "label": "台州市",
                    "level": "3",
                    "code": "3310"
                },
                {
                    "label": "丽水市",
                    "level": "3",
                    "code": "3311"
                }
            ]
        },
        {
            "label": "安徽省",
            "level": "1",
            "code": "3400",
            "cities": [{
                    "label": "合肥市",
                    "level": "2",
                    "code": "3401"
                },
                {
                    "label": "芜湖市",
                    "level": "3",
                    "code": "3402"
                },
                {
                    "label": "蚌埠市",
                    "level": "3",
                    "code": "3403"
                },
                {
                    "label": "淮南市",
                    "level": "3",
                    "code": "3404"
                },
                {
                    "label": "马鞍山市",
                    "level": "3",
                    "code": "3405"
                },
                {
                    "label": "淮北市",
                    "level": "3",
                    "code": "3406"
                },
                {
                    "label": "铜陵市",
                    "level": "3",
                    "code": "3407"
                },
                {
                    "label": "安庆市",
                    "level": "3",
                    "code": "3408"
                },
                {
                    "label": "黄山市",
                    "level": "3",
                    "code": "3410"
                },
                {
                    "label": "滁州市",
                    "level": "3",
                    "code": "3411"
                },
                {
                    "label": "阜阳市",
                    "level": "3",
                    "code": "3412"
                },
                {
                    "label": "宿州市",
                    "level": "3",
                    "code": "3413"
                },
                {
                    "label": "巢湖市",
                    "level": "3",
                    "code": "3414"
                },
                {
                    "label": "六安市",
                    "level": "3",
                    "code": "3415"
                },
                {
                    "label": "亳州市",
                    "level": "3",
                    "code": "3416"
                },
                {
                    "label": "池州市",
                    "level": "3",
                    "code": "3417"
                },
                {
                    "label": "宣城市",
                    "level": "3",
                    "code": "3418"
                }
            ]
        },
        {
            "label": "福建省",
            "level": "1",
            "code": "3500",
            "cities": [{
                    "label": "福州市",
                    "level": "2",
                    "code": "3501"
                },
                {
                    "label": "厦门市",
                    "level": "3",
                    "code": "3502"
                },
                {
                    "label": "莆田市",
                    "level": "3",
                    "code": "3503"
                },
                {
                    "label": "三明市",
                    "level": "3",
                    "code": "3504"
                },
                {
                    "label": "泉州市",
                    "level": "3",
                    "code": "3505"
                },
                {
                    "label": "漳州市",
                    "level": "3",
                    "code": "3506"
                },
                {
                    "label": "南平市",
                    "level": "3",
                    "code": "3507"
                },
                {
                    "label": "龙岩市",
                    "level": "3",
                    "code": "3508"
                },
                {
                    "label": "宁德市",
                    "level": "3",
                    "code": "3509"
                }
            ]
        },
        {
            "label": "江西省",
            "level": "1",
            "code": "3600",
            "cities": [{
                    "label": "南昌市",
                    "level": "2",
                    "code": "3601"
                },
                {
                    "label": "景德镇市",
                    "level": "3",
                    "code": "3602"
                },
                {
                    "label": "萍乡市",
                    "level": "3",
                    "code": "3603"
                },
                {
                    "label": "九江市",
                    "level": "3",
                    "code": "3604"
                },
                {
                    "label": "新余市",
                    "level": "3",
                    "code": "3605"
                },
                {
                    "label": "鹰潭市",
                    "level": "3",
                    "code": "3606"
                },
                {
                    "label": "赣州市",
                    "level": "3",
                    "code": "3607"
                },
                {
                    "label": "吉安市",
                    "level": "3",
                    "code": "3608"
                },
                {
                    "label": "宜春市",
                    "level": "3",
                    "code": "3609"
                },
                {
                    "label": "抚州市",
                    "level": "3",
                    "code": "3610"
                },
                {
                    "label": "上饶市",
                    "level": "3",
                    "code": "3611"
                }
            ]
        },
        {
            "label": "山东省",
            "level": "1",
            "code": "3700",
            "cities": [{
                    "label": "济南市",
                    "level": "2",
                    "code": "3701"
                },
                {
                    "label": "青岛市",
                    "level": "3",
                    "code": "3702"
                },
                {
                    "label": "淄博市",
                    "level": "3",
                    "code": "3703"
                },
                {
                    "label": "枣庄市",
                    "level": "3",
                    "code": "3704"
                },
                {
                    "label": "东营市",
                    "level": "3",
                    "code": "3705"
                },
                {
                    "label": "烟台市",
                    "level": "3",
                    "code": "3706"
                },
                {
                    "label": "潍坊市",
                    "level": "3",
                    "code": "3707"
                },
                {
                    "label": "济宁市",
                    "level": "3",
                    "code": "3708"
                },
                {
                    "label": "泰安市",
                    "level": "3",
                    "code": "3709"
                },
                {
                    "label": "威海市",
                    "level": "3",
                    "code": "3710"
                },
                {
                    "label": "日照市",
                    "level": "3",
                    "code": "3711"
                },
                {
                    "label": "莱芜市",
                    "level": "3",
                    "code": "3712"
                },
                {
                    "label": "临沂市",
                    "level": "3",
                    "code": "3713"
                },
                {
                    "label": "德州市",
                    "level": "3",
                    "code": "3714"
                },
                {
                    "label": "聊城市",
                    "level": "3",
                    "code": "3715"
                },
                {
                    "label": "滨州市",
                    "level": "3",
                    "code": "3716"
                },
                {
                    "label": "菏泽市",
                    "level": "3",
                    "code": "3717"
                }
            ]
        },
        {
            "label": "河南省",
            "level": "1",
            "code": "4100",
            "cities": [{
                    "label": "郑州市",
                    "level": "2",
                    "code": "4101"
                },
                {
                    "label": "开封市",
                    "level": "3",
                    "code": "4102"
                },
                {
                    "label": "洛阳市",
                    "level": "3",
                    "code": "4103"
                },
                {
                    "label": "平顶山市",
                    "level": "3",
                    "code": "4104"
                },
                {
                    "label": "安阳市",
                    "level": "3",
                    "code": "4105"
                },
                {
                    "label": "鹤壁市",
                    "level": "3",
                    "code": "4106"
                },
                {
                    "label": "新乡市",
                    "level": "3",
                    "code": "4107"
                },
                {
                    "label": "焦作市",
                    "level": "3",
                    "code": "4108"
                },
                {
                    "label": "濮阳市",
                    "level": "3",
                    "code": "4109"
                },
                {
                    "label": "许昌市",
                    "level": "3",
                    "code": "4110"
                },
                {
                    "label": "漯河市",
                    "level": "3",
                    "code": "4111"
                },
                {
                    "label": "三门峡市",
                    "level": "3",
                    "code": "4112"
                },
                {
                    "label": "南阳市",
                    "level": "3",
                    "code": "4113"
                },
                {
                    "label": "商丘市",
                    "level": "3",
                    "code": "4114"
                },
                {
                    "label": "信阳市",
                    "level": "3",
                    "code": "4115"
                },
                {
                    "label": "周口市",
                    "level": "3",
                    "code": "4116"
                },
                {
                    "label": "驻马店市",
                    "level": "3",
                    "code": "4117"
                }
            ]
        },
        {
            "label": "湖北省",
            "level": "1",
            "code": "4200",
            "cities": [{
                    "label": "武汉市",
                    "level": "2",
                    "code": "4201"
                },
                {
                    "label": "黄石市",
                    "level": "3",
                    "code": "4202"
                },
                {
                    "label": "十堰市",
                    "level": "3",
                    "code": "4203"
                },
                {
                    "label": "宜昌市",
                    "level": "3",
                    "code": "4205"
                },
                {
                    "label": "襄樊市",
                    "level": "3",
                    "code": "4206"
                },
                {
                    "label": "鄂州市",
                    "level": "3",
                    "code": "4207"
                },
                {
                    "label": "荆门市",
                    "level": "3",
                    "code": "4208"
                },
                {
                    "label": "孝感市",
                    "level": "3",
                    "code": "4209"
                },
                {
                    "label": "荆州市",
                    "level": "3",
                    "code": "4210"
                },
                {
                    "label": "黄冈市",
                    "level": "3",
                    "code": "4211"
                },
                {
                    "label": "咸宁市",
                    "level": "3",
                    "code": "4212"
                },
                {
                    "label": "随州市",
                    "level": "3",
                    "code": "4213"
                },
                {
                    "label": "恩施土家族苗族自治州",
                    "level": "3",
                    "code": "4228"
                }
            ]
        },
        {
            "label": "湖南省",
            "level": "1",
            "code": "4300",
            "cities": [{
                    "label": "长沙市",
                    "level": "2",
                    "code": "4301"
                },
                {
                    "label": "株洲市",
                    "level": "3",
                    "code": "4302"
                },
                {
                    "label": "湘潭市",
                    "level": "3",
                    "code": "4303"
                },
                {
                    "label": "衡阳市",
                    "level": "3",
                    "code": "4304"
                },
                {
                    "label": "邵阳市",
                    "level": "3",
                    "code": "4305"
                },
                {
                    "label": "岳阳市",
                    "level": "3",
                    "code": "4306"
                },
                {
                    "label": "常德市",
                    "level": "3",
                    "code": "4307"
                },
                {
                    "label": "张家界市",
                    "level": "3",
                    "code": "4308"
                },
                {
                    "label": "益阳市",
                    "level": "3",
                    "code": "4309"
                },
                {
                    "label": "郴州市",
                    "level": "3",
                    "code": "4310"
                },
                {
                    "label": "永州市",
                    "level": "3",
                    "code": "4311"
                },
                {
                    "label": "怀化市",
                    "level": "3",
                    "code": "4312"
                },
                {
                    "label": "娄底市",
                    "level": "3",
                    "code": "4313"
                },
                {
                    "label": "湘西土家族苗族自治州",
                    "level": "3",
                    "code": "4331"
                }
            ]
        },
        {
            "label": "广东省",
            "level": "1",
            "code": "4400",
            "cities": [{
                    "label": "广州市",
                    "level": "2",
                    "code": "4401"
                },
                {
                    "label": "韶关市",
                    "level": "3",
                    "code": "4402"
                },
                {
                    "label": "深圳市",
                    "level": "3",
                    "code": "4403"
                },
                {
                    "label": "珠海市",
                    "level": "3",
                    "code": "4404"
                },
                {
                    "label": "汕头市",
                    "level": "3",
                    "code": "4405"
                },
                {
                    "label": "佛山市",
                    "level": "3",
                    "code": "4406"
                },
                {
                    "label": "江门市",
                    "level": "3",
                    "code": "4407"
                },
                {
                    "label": "湛江市",
                    "level": "3",
                    "code": "4408"
                },
                {
                    "label": "茂名市",
                    "level": "3",
                    "code": "4409"
                },
                {
                    "label": "肇庆市",
                    "level": "3",
                    "code": "4412"
                },
                {
                    "label": "惠州市",
                    "level": "3",
                    "code": "4413"
                },
                {
                    "label": "梅州市",
                    "level": "3",
                    "code": "4414"
                },
                {
                    "label": "汕尾市",
                    "level": "3",
                    "code": "4415"
                },
                {
                    "label": "河源市",
                    "level": "3",
                    "code": "4416"
                },
                {
                    "label": "阳江市",
                    "level": "3",
                    "code": "4417"
                },
                {
                    "label": "清远市",
                    "level": "3",
                    "code": "4418"
                },
                {
                    "label": "东莞市",
                    "level": "3",
                    "code": "4419"
                },
                {
                    "label": "中山市",
                    "level": "3",
                    "code": "4420"
                },
                {
                    "label": "潮州市",
                    "level": "3",
                    "code": "4451"
                },
                {
                    "label": "揭阳市",
                    "level": "3",
                    "code": "4452"
                },
                {
                    "label": "云浮市",
                    "level": "3",
                    "code": "4453"
                }
            ]
        },
        {
            "label": "广西壮族自治区",
            "level": "1",
            "code": "4500",
            "cities": [{
                    "label": "南宁市",
                    "level": "2",
                    "code": "4501"
                },
                {
                    "label": "柳州市",
                    "level": "3",
                    "code": "4502"
                },
                {
                    "label": "桂林市",
                    "level": "3",
                    "code": "4503"
                },
                {
                    "label": "梧州市",
                    "level": "3",
                    "code": "4504"
                },
                {
                    "label": "北海市",
                    "level": "3",
                    "code": "4505"
                },
                {
                    "label": "防城港市",
                    "level": "3",
                    "code": "4506"
                },
                {
                    "label": "钦州市",
                    "level": "3",
                    "code": "4507"
                },
                {
                    "label": "贵港市",
                    "level": "3",
                    "code": "4508"
                },
                {
                    "label": "玉林市",
                    "level": "3",
                    "code": "4509"
                },
                {
                    "label": "百色市",
                    "level": "3",
                    "code": "4510"
                },
                {
                    "label": "贺州市",
                    "level": "3",
                    "code": "4511"
                },
                {
                    "label": "河池市",
                    "level": "3",
                    "code": "4512"
                },
                {
                    "label": "来宾市",
                    "level": "3",
                    "code": "4513"
                },
                {
                    "label": "崇左市",
                    "level": "3",
                    "code": "4514"
                }
            ]
        },
        {
            "label": "海南省",
            "level": "1",
            "code": "4600",
            "cities": [{
                    "label": "海口市",
                    "level": "2",
                    "code": "4601"
                },
                {
                    "label": "三亚市",
                    "level": "3",
                    "code": "4602"
                },
                {
                    "label": "三沙市",
                    "level": "4",
                    "code": "4603"
                },
                {
                    "label": "儋州市",
                    "level": "5",
                    "code": "4604"
                }, {
                    "label": "五指山市",
                    "level": "6",
                    "code": "4605"
                },
                {
                    "label": "文昌市",
                    "level": "7",
                    "code": "4606"
                },
                {
                    "label": "琼海市",
                    "level": "8",
                    "code": "4607"
                },
                {
                    "label": "万宁市",
                    "level": "9",
                    "code": "4608"
                },
                {
                    "label": "东方市",
                    "level": "10",
                    "code": "4609"
                },
                {
                    "label": "定安县",
                    "level": "11",
                    "code": "4610"
                },
                {
                    "label": "屯昌县",
                    "level": "12",
                    "code": "4611"
                },
                {
                    "label": "澄迈县",
                    "level": "13",
                    "code": "4612"
                },
                {
                    "label": "临高县",
                    "level": "14",
                    "code": "4613"
                },
                {
                    "label": "白沙黎族自治县",
                    "level": "15",
                    "code": "4614"
                },
                {
                    "label": "昌江黎族自治县",
                    "level": "16",
                    "code": "4615"
                },
                {
                    "label": "乐东黎族自治县",
                    "level": "17",
                    "code": "4616"
                },
                {
                    "label": "陵水黎族自治县",
                    "level": "18",
                    "code": "4617"
                },
                {
                    "label": "保亭黎族苗族自治县",
                    "level": "19",
                    "code": "4618"
                },
                {
                    "label": "琼中黎族苗族自治县",
                    "level": "20",
                    "code": "4619"
                }                   
            ]
        },
        {
            "label": "重庆市",
            "level": "1",
            "code": "5000",
            "cities": [{
                "label": "重庆市",
                "level": "1",
                "code": "5000"
            }]
        },
        {
            "label": "四川省",
            "level": "1",
            "code": "5100",
            "cities": [{
                    "label": "成都市",
                    "level": "2",
                    "code": "5101"
                },
                {
                    "label": "自贡市",
                    "level": "3",
                    "code": "5103"
                },
                {
                    "label": "攀枝花市",
                    "level": "3",
                    "code": "5104"
                },
                {
                    "label": "泸州市",
                    "level": "3",
                    "code": "5105"
                },
                {
                    "label": "德阳市",
                    "level": "3",
                    "code": "5106"
                },
                {
                    "label": "绵阳市",
                    "level": "3",
                    "code": "5107"
                },
                {
                    "label": "广元市",
                    "level": "3",
                    "code": "5108"
                },
                {
                    "label": "遂宁市",
                    "level": "3",
                    "code": "5109"
                },
                {
                    "label": "内江市",
                    "level": "3",
                    "code": "5110"
                },
                {
                    "label": "乐山市",
                    "level": "3",
                    "code": "5111"
                },
                {
                    "label": "南充市",
                    "level": "3",
                    "code": "5113"
                },
                {
                    "label": "眉山市",
                    "level": "3",
                    "code": "5114"
                },
                {
                    "label": "宜宾市",
                    "level": "3",
                    "code": "5115"
                },
                {
                    "label": "广安市",
                    "level": "3",
                    "code": "5116"
                },
                {
                    "label": "达州市",
                    "level": "3",
                    "code": "5117"
                },
                {
                    "label": "雅安市",
                    "level": "3",
                    "code": "5118"
                },
                {
                    "label": "巴中市",
                    "level": "3",
                    "code": "5119"
                },
                {
                    "label": "资阳市",
                    "level": "3",
                    "code": "5120"
                },
                {
                    "label": "阿坝藏族羌族自治州",
                    "level": "3",
                    "code": "5132"
                },
                {
                    "label": "甘孜藏族自治州",
                    "level": "3",
                    "code": "5133"
                },
                {
                    "label": "凉山彝族自治州",
                    "level": "3",
                    "code": "5134"
                }
            ]
        },
        {
            "label": "贵州省",
            "level": "1",
            "code": "5200",
            "cities": [{
                    "label": "贵阳市",
                    "level": "2",
                    "code": "5201"
                },
                {
                    "label": "六盘水市",
                    "level": "3",
                    "code": "5202"
                },
                {
                    "label": "遵义市",
                    "level": "3",
                    "code": "5203"
                },
                {
                    "label": "安顺市",
                    "level": "3",
                    "code": "5204"
                },
                {
                    "label": "铜仁地区",
                    "level": "3",
                    "code": "5222"
                },
                {
                    "label": "黔西南布依族苗族自治州",
                    "level": "3",
                    "code": "5223"
                },
                {
                    "label": "毕节地区",
                    "level": "3",
                    "code": "5224"
                },
                {
                    "label": "黔东南苗族侗族自治州",
                    "level": "3",
                    "code": "5226"
                },
                {
                    "label": "黔南布依族苗族自治州",
                    "level": "3",
                    "code": "5227"
                }
            ]
        },
        {
            "label": "云南省",
            "level": "1",
            "code": "5300",
            "cities": [{
                    "label": "昆明市",
                    "level": "2",
                    "code": "5301"
                },
                {
                    "label": "曲靖市",
                    "level": "3",
                    "code": "5303"
                },
                {
                    "label": "玉溪市",
                    "level": "3",
                    "code": "5304"
                },
                {
                    "label": "保山市",
                    "level": "3",
                    "code": "5305"
                },
                {
                    "label": "昭通市",
                    "level": "3",
                    "code": "5306"
                },
                {
                    "label": "丽江市",
                    "level": "3",
                    "code": "5307"
                },
                {
                    "label": "普洱市",
                    "level": "3",
                    "code": "5308"
                },
                {
                    "label": "临沧市",
                    "level": "3",
                    "code": "5309"
                },
                {
                    "label": "楚雄彝族自治州",
                    "level": "3",
                    "code": "5323"
                },
                {
                    "label": "红河哈尼族彝族自治州",
                    "level": "3",
                    "code": "5325"
                },
                {
                    "label": "文山壮族苗族自治州",
                    "level": "3",
                    "code": "5326"
                },
                {
                    "label": "西双版纳傣族自治州",
                    "level": "3",
                    "code": "5328"
                },
                {
                    "label": "大理白族自治州",
                    "level": "3",
                    "code": "5329"
                },
                {
                    "label": "德宏傣族景颇族自治州",
                    "level": "3",
                    "code": "5331"
                },
                {
                    "label": "怒江傈僳族自治州",
                    "level": "3",
                    "code": "5333"
                },
                {
                    "label": "迪庆藏族自治州",
                    "level": "3",
                    "code": "5334"
                }
            ]
        },
        {
            "label": "西藏自治区",
            "level": "1",
            "code": "5400",
            "cities": [{
                    "label": "拉萨市",
                    "level": "2",
                    "code": "5401"
                },
                {
                    "label": "昌都地区",
                    "level": "3",
                    "code": "5421"
                },
                {
                    "label": "山南地区",
                    "level": "3",
                    "code": "5422"
                },
                {
                    "label": "日喀则地区",
                    "level": "3",
                    "code": "5423"
                },
                {
                    "label": "那曲地区",
                    "level": "3",
                    "code": "5424"
                },
                {
                    "label": "阿里地区",
                    "level": "3",
                    "code": "5425"
                },
                {
                    "label": "林芝地区",
                    "level": "3",
                    "code": "5426"
                }
            ]
        },
        {
            "label": "陕西省",
            "level": "1",
            "code": "6100",
            "cities": [{
                    "label": "西安市",
                    "level": "2",
                    "code": "6101"
                },
                {
                    "label": "铜川市",
                    "level": "3",
                    "code": "6102"
                },
                {
                    "label": "宝鸡市",
                    "level": "3",
                    "code": "6103"
                },
                {
                    "label": "咸阳市",
                    "level": "3",
                    "code": "6104"
                },
                {
                    "label": "渭南市",
                    "level": "3",
                    "code": "6105"
                },
                {
                    "label": "延安市",
                    "level": "3",
                    "code": "6106"
                },
                {
                    "label": "汉中市",
                    "level": "3",
                    "code": "6107"
                },
                {
                    "label": "榆林市",
                    "level": "3",
                    "code": "6108"
                },
                {
                    "label": "安康市",
                    "level": "3",
                    "code": "6109"
                },
                {
                    "label": "商洛市",
                    "level": "3",
                    "code": "6110"
                }
            ]
        },
        {
            "label": "甘肃省",
            "level": "1",
            "code": "6200",
            "cities": [{
                    "label": "兰州市",
                    "level": "2",
                    "code": "6201"
                },
                {
                    "label": "嘉峪关市",
                    "level": "3",
                    "code": "6202"
                },
                {
                    "label": "金昌市",
                    "level": "3",
                    "code": "6203"
                },
                {
                    "label": "白银市",
                    "level": "3",
                    "code": "6204"
                },
                {
                    "label": "天水市",
                    "level": "3",
                    "code": "6205"
                },
                {
                    "label": "武威市",
                    "level": "3",
                    "code": "6206"
                },
                {
                    "label": "张掖市",
                    "level": "3",
                    "code": "6207"
                },
                {
                    "label": "平凉市",
                    "level": "3",
                    "code": "6208"
                },
                {
                    "label": "酒泉市",
                    "level": "3",
                    "code": "6209"
                },
                {
                    "label": "庆阳市",
                    "level": "3",
                    "code": "6210"
                },
                {
                    "label": "定西市",
                    "level": "3",
                    "code": "6211"
                },
                {
                    "label": "陇南市",
                    "level": "3",
                    "code": "6212"
                },
                {
                    "label": "临夏回族自治州",
                    "level": "3",
                    "code": "6229"
                },
                {
                    "label": "甘南藏族自治州",
                    "level": "3",
                    "code": "6230"
                }
            ]
        },
        {
            "label": "青海省",
            "level": "1",
            "code": "6300",
            "cities": [{
                    "label": "西宁市",
                    "level": "2",
                    "code": "6301"
                },
                {
                    "label": "海东地区",
                    "level": "3",
                    "code": "6321"
                },
                {
                    "label": "海北藏族自治州",
                    "level": "3",
                    "code": "6322"
                },
                {
                    "label": "黄南藏族自治州",
                    "level": "3",
                    "code": "6323"
                },
                {
                    "label": "海南藏族自治州",
                    "level": "3",
                    "code": "6325"
                },
                {
                    "label": "果洛藏族自治州",
                    "level": "3",
                    "code": "6326"
                },
                {
                    "label": "玉树藏族自治州",
                    "level": "3",
                    "code": "6327"
                },
                {
                    "label": "海西蒙古族藏族自治州",
                    "level": "3",
                    "code": "6328"
                }
            ]
        },
        {
            "label": "宁夏回族自治区",
            "level": "1",
            "code": "6400",
            "cities": [{
                    "label": "银川市",
                    "level": "2",
                    "code": "6401"
                },
                {
                    "label": "石嘴山市",
                    "level": "3",
                    "code": "6402"
                },
                {
                    "label": "吴忠市",
                    "level": "3",
                    "code": "6403"
                },
                {
                    "label": "固原市",
                    "level": "3",
                    "code": "6404"
                },
                {
                    "label": "中卫市",
                    "level": "3",
                    "code": "6405"
                }
            ]
        },
        {
            "label": "新疆维吾尔自治区",
            "level": "1",
            "code": "6500",
            "cities": [{
                    "label": "乌鲁木齐市",
                    "level": "2",
                    "code": "6501"
                },
                {
                    "label": "克拉玛依市",
                    "level": "3",
                    "code": "6502"
                },
                {
                    "label": "吐鲁番地区",
                    "level": "3",
                    "code": "6521"
                },
                {
                    "label": "哈密地区",
                    "level": "3",
                    "code": "6522"
                },
                {
                    "label": "昌吉回族自治州",
                    "level": "3",
                    "code": "6523"
                },
                {
                    "label": "博尔塔拉蒙古自治州",
                    "level": "3",
                    "code": "6527"
                },
                {
                    "label": "巴音郭楞蒙古自治州",
                    "level": "3",
                    "code": "6528"
                },
                {
                    "label": "阿克苏地区",
                    "level": "3",
                    "code": "6529"
                },
                {
                    "label": "克孜勒苏柯尔克孜自治州",
                    "level": "3",
                    "code": "6530"
                },
                {
                    "label": "喀什地区",
                    "level": "3",
                    "code": "6531"
                },
                {
                    "label": "和田地区",
                    "level": "3",
                    "code": "6532"
                },
                {
                    "label": "伊犁哈萨克自治州",
                    "level": "3",
                    "code": "6540"
                },
                {
                    "label": "塔城地区",
                    "level": "3",
                    "code": "6542"
                },
                {
                    "label": "阿勒泰地区",
                    "level": "3",
                    "code": "6543"
                }
            ]
        },
        {
            "label": "台湾省",
            "level": "1",
            "code": "7100",
            "cities": [{
                "label": "台湾省",
                "level": "1",
                "code": "7100"
            }]
        },
        {
            "label": "香港特别行政区",
            "level": "1",
            "code": "8100",
            "cities": [{
                "label": "香港特别行政区",
                "level": "1",
                "code": "8100"
            }]
        },
        {
            "label": "澳门特别行政区",
            "level": "1",
            "code": "8200",
            "cities": [{
                "label": "澳门特别行政区",
                "level": "1",
                "code": "8200"
            }]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/assets/js/city.js